import { removeGradeSchemas, setGradeSchemas } from './gradeSchemaAction'
import { Constants } from './gradeSchemaConstants'
import { GradeSchema } from '../../../../model/apprenticeModuleGrade.model'

type Actions =
  | ReturnType<typeof setGradeSchemas>
  | ReturnType<typeof removeGradeSchemas>

export const gradeSchemaReducer = (
  state: GradeSchema[] = [],
  action: Actions
) => {
  switch (action.type) {
    case Constants.SET_GRADE_SCHEMAS:
      return [...state, ...action.payload]
    case Constants.REMOVE_GRADE_SCHEMAS:
      return [] as GradeSchema[]
    default:
      return state
  }
}